import styled from 'styled-components/macro';

export const ColumnCenter = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

// 机器人回复消息内容
export const RobotContent = styled.div`
  background: #FFFFFF;
  border-radius: 10px;
  padding: 15px;
  font-family: Squad-Regular, Squad;
  font-weight: 400;
  color: #11202B;
  font-size: 16px;
  line-height: 21px;
  max-width: 65%;
`;
